import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { loginEduLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy login-edu envelope.
 *
 * `type: z.literal('zero')` is required (no `.optional()`): a login-edu widget
 * created inside a zero block must carry the tag end-to-end so downstream
 * consumers (positioning hosts, render branches) recognise the placement. The
 * host-app factory copies `meta.type` onto the entity at creation time.
 *
 * Inner data uses {@link loginEduLegacyZeroDataSchema} — the extended-position
 * grid instead of the default variant's simple grid.
 */
export const loginEduLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('login-edu'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: loginEduLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
